module.exports = __webpack_public_path__ + "static/basics_of_video_processing_3-53d320ea1828a19820350b0eb1455aa2.png";